import { PulseFilters, pulseFiltersSchema } from './types'

import { api } from 'api'
import { z } from 'zod'

const payRateMetricsResponse = z.object({
  avg_pay_rate: z.number(),
  avg_bonus_rate: z.number(),
  avg_pay_rate_with_company_bonus: z.number(),
})

export type PayRateMetrics = z.infer<typeof payRateMetricsResponse>

export async function getPayRateMetrics(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/cost/pay_rate_metrics', data, { signal })
    .then((response) => response.data)
    .then(payRateMetricsResponse.parse)
}
